export default [
  // 学生端
  {
    path: '/checkIn/studentCheckinIndex',
    name: '考勤',
    component: () => import(/* webpackChunkName: "studentCheckinIndex" */ '../views/CheckIn/studentCheckin/studentCheckinIndex/studentCheckinIndex.vue')
  },
  {
    path: '/checkIn/studentGPS',
    name: '确认签到位置',
    component: () => import(/* webpackChunkName: "studentCheckin" */ '../views/CheckIn/studentCheckin/CheckinTypeItems/GPS.vue')
  },
  {
    path: '/checkIn/studentNumber',
    name: '数字考勤',
    component: () => import(/* webpackChunkName: "studentCheckin" */ '../views/CheckIn/studentCheckin/CheckinTypeItems/NumberStudent.vue')
  },
  {
    path: '/checkIn/checkinSuccess',
    name: '',
    component: () => import(/* webpackChunkName: "checkinSuccess" */ '../views/CheckIn/studentCheckin/checkinSuccess/checkinSuccess.vue')
  },
  {
    path: '/checkIn/fail',
    name: '签到失败',
    component: () => import(/* webpackChunkName: "checkinFail" */ '@/views/CheckIn/studentCheckin/CheckinFail/fail.vue')
  },
  {
    path: '/checkIn/checkinCodeResult',
    name: '',
    component: () => import(/* webpackChunkName: "checkinCodeResult" */ '../views/CheckIn/studentCheckin/checkinCodeResult/checkinCodeResult.vue')
  },
  // 教师端
  {
    path: '/checkIn/teacherCheckinIndex',
    name: '',
    component: () => import(/* webpackChunkName: "teacherCheckin" */ '../views/CheckIn/teacherCheckin/teacherCheckinIndex/teacherCheckinIndex.vue')
  },
  {
    path: '/checkIn/teaCheckinPage',
    name: '',
    component: () => import(/* webpackChunkName: "teacherCheckin" */ '../views/CheckIn/teacherCheckin/checkinPage/checkinPage.vue')
  },
  {
    path: '/checkIn/teaCheckinDetail',
    name: '',
    component: () => import(/* webpackChunkName: "teacherCheckin" */ '../views/CheckIn/teacherCheckin/checkinDetail/checkinDetail.vue')
  },
  {
    path: '/checkIn/teaCheckinEdit',
    name: '',
    component: () => import(/* webpackChunkName: "teacherCheckin" */ '../views/CheckIn/teacherCheckin/checkinEdit/checkinEdit.vue')
  },
  {
    path: '/checkIn/teaCheckinAdd',
    name: '',
    component: () => import(/* webpackChunkName: "teacherCheckin" */ '../views/CheckIn/teacherCheckin/checkinAdd/checkinAdd.vue')
  },
  {
    path: '/checkIn/counselorCheckin',
    name: '',
    component: () => import(/* webpackChunkName: "counselorCheckin" */ '../views/CheckIn/counselorCheckin/checkinDetail/checkinDetail.vue')
  },
  {
    path: '/checkIn/counselorAdminClassCheckin',
    name: '考勤异常情况（行政班）',
    component: () => import(/* webpackChunkName: "counselorAdminClassCheckin" */ '../views/CheckIn/counselorCheckin/checkinDetail/checkinAdminClassDetail.vue')
  },
];
